<template>
  <div>
    <el-dialog
      :title="errorData.message"
      :close-on-click-modal="false"
      :visible.sync="errorVisible"
      @close="closeError"
      width="600px"
      class="schedule-check-modal-contain"
    >
      <div class="schedule-check-error-info">
        <div class="schedule-check-error-info-p">
          <em class="el-icon-warning error-icon" v-if="errorData.message.indexOf($t('schedule.statusLog0')) >=0"></em>
          <em class="el-icon-circle-check success-icon" v-else></em>
          {{ $t("courseTask.downInfoTip") }}
        </div>
        <div class="schedule-check-error-info-p">
          <div @click="downloadError" class="download-a el-icon-cloudy">{{
            downloadNameInfo
          }}</div>
        </div>
      </div>
      <div class="schedule-check-footer">
        <el-button
          type="primary"
          @click="closeError()"
          :loading="loading"
          style="width: 88px"
          >{{ $t('confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  props: {
    taskName: {
      type: String
    },
    errorVisible: {
      type: Boolean
    },
    errorData: {
      type: Object
    }
  },
   data() {
    return {
      loading: false,
      downloadName: '',
      downloadNameInfo: '',
      src: ''
    };
  },
  methods: {
    downloadError () {
      const a = document.createElement('a');
      a.download = this.downloadName;
      a.href = this.src;
      document.getElementsByTagName('body')[0].appendChild(a);
      a.click();
      document.getElementsByTagName('body')[0].removeChild(a);
    },
    dataTransformBlob () {
      const fileStr = window.atob(this.errorData.data);
      let n = fileStr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = fileStr.charCodeAt(n);
      }
      const blob = new Blob([u8arr], {
        type: 'application/vnd.ms-excel',
      });
      this.downloadNameInfo = this.$t('courseTask.importDetail') +  dayjs().format('YYYY-MM-DD HH:mm:ss');
      this.downloadName = `${this.taskName + this.$t('courseTask.importDetail') + 
        dayjs().format('YYYY-MM-DD HH:mm:ss')  }.xls`;
      this.src = URL.createObjectURL(blob);
    },
    closeError (val) {
      this.$emit('closeModal', val);
    }
  },
  mounted() {
    this.dataTransformBlob();
  }
};
</script>
<style lang="scss" scoped>
.schedule-check-modal-contain {
  .schedule-check-error-info {
    margin: 0 0 20px 0;
    border: 1px solid #b2b0b4;
    border-radius: 4px;
    padding: 22px 0;
    font-size: 16px;
    text-align: center;
    .schedule-check-error-info-p {
      margin-bottom: 12px;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
    }
    .error-icon {
      display: inline-block;
      color: #ffa92e;
    }
    .success-icon {
      display: inline-block;
      color: #67C23A;
    }
    .download-a {
      color: #409eff;
      cursor: pointer;
    }
  }
  .schedule-check-footer {
    text-align: center;
  }
} 
</style>
    